import { isObject } from './getTypeofItem';

export const isUndefinedValue = val => {
  return typeof val === 'undefined';
};

export const isNullValue = val => {
  return val === null;
};

export const isEmptyObject = obj => {
  if (!isObject(obj)) return;

  return Object.keys(obj).length === 0;
};
